/* Novium-9 theme — global.js */
(function () {
  'use strict';

  var money = function (cents) {
    try {
      return (window.Shopify && Shopify.currency)
        ? '$' + (cents / 100).toFixed(2)
        : '$' + (cents / 100).toFixed(2);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* ---------- Mobile menu (full-height drawer) ---------- */
  function initMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    var closeBtn = document.querySelector('[data-menu-close]');
    if (!toggle || !menu) return;
    function close() {
      document.documentElement.classList.remove('menu-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
    toggle.addEventListener('click', function () {
      var open = document.documentElement.classList.toggle('menu-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) close();
    });
    document.addEventListener('click', function (e) {
      if (!document.documentElement.classList.contains('menu-open')) return;
      if (menu.contains(e.target) || toggle.contains(e.target)) return;
      close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ---------- Search toggle ---------- */
  function initSearch() {
    var btn = document.querySelector('[data-search-toggle]');
    var panel = document.querySelector('[data-search-panel]');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var open = panel.classList.toggle('is-open');
      if (open) { var i = panel.querySelector('input[type="search"]'); if (i) i.focus(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') panel.classList.remove('is-open');
    });
  }

  /* ---------- Accordions ([data-acc] wrapper, [data-acc-trigger] button) ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-acc-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-acc-item]');
        if (!item) return;
        var isOpen = item.classList.contains('open');
        var group = btn.closest('[data-acc]');
        if (group && group.hasAttribute('data-acc-single')) {
          group.querySelectorAll('[data-acc-item].open').forEach(function (o) { if (o !== item) o.classList.remove('open'); });
        }
        item.classList.toggle('open', !isOpen);
        btn.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
      });
    });
  }

  /* ---------- Cart count refresh ---------- */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      }).catch(function () {});
  }

  /* ---------- Toast ---------- */
  function toast(msg, href, label) {
    var t = document.createElement('div');
    t.className = 'n9-toast';
    t.innerHTML = '<span>' + msg + '</span>' + (href ? ' <a href="' + href + '">' + (label || 'View') + '</a>' : '');
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('show'); });
    setTimeout(function () { t.classList.remove('show'); setTimeout(function () { t.remove(); }, 300); }, 4200);
  }

  /* ---------- Announcement bar rotator ---------- */
  /* Cycles .pm-item messages with a slide-up + fade (CSS transitions on
     .is-active/.is-leaving). No-ops with fewer than 2 messages. */
  function initPromoRotator() {
    var bar = document.querySelector('[data-promo-rotator]');
    if (!bar) return;
    var items = bar.querySelectorAll('.pm-item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      var current = items[i];
      i = (i + 1) % items.length;
      var next = items[i];
      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      setTimeout(function () { current.classList.remove('is-leaving'); }, 550);
      next.classList.add('is-active');
    }, 3000);
  }

  /* ---------- Add to cart (any form[data-product-form]) ---------- */
  function initAddToCart() {
    document.querySelectorAll('form[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var original = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.classList.add('loading'); btn.innerHTML = 'Adding…'; }
        var data = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (btn) { btn.disabled = false; btn.classList.remove('loading'); btn.innerHTML = original; }
            if (!res.ok) { toast(res.body.description || 'Could not add to cart.'); return; }
            refreshCartCount();
            var cartType = form.getAttribute('data-cart-type') || 'ajax';
            if (cartType === 'page') { window.location.href = '/cart'; return; }
            toast('Added to cart.', '/cart', 'View cart');
          })
          .catch(function () {
            if (btn) { btn.disabled = false; btn.classList.remove('loading'); btn.innerHTML = original; }
            toast('Something went wrong. Please try again.');
          });
      });
    });
  }

  /* ---------- Cart page: quantity + remove ---------- */
  function initCartPage() {
    var root = document.querySelector('[data-cart-root]');
    if (!root) return;
    root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-qty-step]');
      if (step) {
        var input = step.parentNode.querySelector('input[data-qty]');
        var v = parseInt(input.value, 10) || 0;
        v += parseInt(step.getAttribute('data-qty-step'), 10);
        if (v < 0) v = 0;
        input.value = v;
        updateLine(input.getAttribute('data-line'), v);
      }
      var rm = e.target.closest('[data-remove]');
      if (rm) { e.preventDefault(); updateLine(rm.getAttribute('data-line'), 0); }
    });
    root.addEventListener('change', function (e) {
      var input = e.target.closest('input[data-qty]');
      if (input) updateLine(input.getAttribute('data-line'), parseInt(input.value, 10) || 0);
    });
    function updateLine(line, qty) {
      root.classList.add('is-loading');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
      }).then(function (r) { return r.json(); }).then(function () {
        window.location.reload();
      }).catch(function () { root.classList.remove('is-loading'); });
    }
  }

  /* ---------- FAQ accordion (.faq-q inside .faq-item) ---------- */
  function initFaq() {
    // Reading scrollHeight (layout) and writing style back inside the same loop forces
    // a synchronous reflow per open FAQ item, at DOMContentLoaded -- right when Shopify's
    // and Judge.me's inline head scripts have already dirtied layout once. Split into an
    // all-reads pass then an all-writes pass so the browser only reflows once, if at all.
    var pending = [];
    document.querySelectorAll('.faq-q').forEach(function (q) {
      var item = q.closest('.faq-item');
      var a = item ? item.querySelector('.faq-a') : null;
      if (a && item.classList.contains('open')) pending.push(a);
      q.addEventListener('click', function () {
        var open = item.classList.toggle('open');
        if (a) a.style.maxHeight = open ? a.scrollHeight + 'px' : '0';
      });
    });
    if (!pending.length) return;
    var heights = pending.map(function (a) { return a.scrollHeight; });          // all reads
    pending.forEach(function (a, i) { a.style.maxHeight = heights[i] + 'px'; }); // all writes
  }

  /* ---------- Product gallery thumbs ---------- */
  function initGallery() {
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-thumb');
        document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        document.querySelectorAll('[data-slide]').forEach(function (s) {
          s.classList.toggle('active', s.getAttribute('data-slide') === i);
        });
      });
    });
  }

  /* ---------- Buy box (one-time plan cards) ---------- */
  function initBuyBox() {
    var form = document.querySelector('[data-buybox]');
    if (!form) return;
    var idInput = form.querySelector('[data-id-input]');
    var addBtn = form.querySelector('[data-add-btn]') || form.querySelector('button[type="submit"]');
    var barPrice = document.querySelector('[data-bar-price]');
    var barBtn = document.querySelector('[data-buybar-add]');
    function select(card) {
      form.querySelectorAll('[data-plan-card]').forEach(function (x) { x.classList.remove('sel'); });
      card.classList.add('sel');
      var radio = card.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      if (idInput) idInput.value = card.getAttribute('data-id');
      /* Availability follows the selected card, not the render-time default */
      var avail = card.getAttribute('data-available') !== 'false';
      if (addBtn) {
        addBtn.disabled = !avail;
        if (avail) { addBtn.innerHTML = 'Add to cart &middot; <span data-add-price>' + (card.getAttribute('data-add') || '') + '</span>'; }
        else { addBtn.innerHTML = 'Sold out, choose another option'; }
      }
      if (barBtn) barBtn.disabled = !avail;
      if (barPrice) barPrice.innerHTML = card.getAttribute('data-bar') || card.getAttribute('data-add') || '';
    }
    form.querySelectorAll('[data-plan-card]').forEach(function (card) {
      card.addEventListener('click', function () { select(card); });
    });
    var bar = document.querySelector('[data-buybar-add]');
    if (bar) bar.addEventListener('click', function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else { var s = form.querySelector('[type="submit"]'); if (s) s.click(); }
    });

    /* Reveal the sticky bar only after the main Add-to-cart scrolls out of view upward */
    var barEl = document.querySelector('.buybar');
    var anchor = form.querySelector('.addwrap') || form;
    if (barEl && anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var scrolledPast = !en.isIntersecting && en.boundingClientRect.top < 0;
          barEl.classList.toggle('show', scrolledPast);
        });
      }, { threshold: 0 });
      io.observe(anchor);
    }
  }

  /* Reveal the site-wide sticky bar only once the shopper has scrolled past the hero */
  function initStickyMobileCta() {
    var bar = document.querySelector('.mobile-cta');
    if (!bar) return;
    var threshold = window.innerHeight * 0.5;
    var ticking = false;
    function update() {
      bar.classList.toggle('show', window.scrollY > threshold);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    initSearch();
    initAccordions();
    initFaq();
    initGallery();
    initBuyBox();
    initAddToCart();
    initCartPage();
    initStickyMobileCta();
    initPromoRotator();
    refreshCartCount();
  });
})();
